function SubHeading(props){
    return (
        <h2>{props.text}</h2>
    )
}

export default SubHeading;